import * as React from 'react'
import { BLUE } from '../../colors'

const Plus = (props) => (
  <svg
    width='24'
    height='25'
    viewBox='0 0 24 25'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20 10.5h-6.5V4a1.5 1.5 0 1 0-3 0v6.5H4a1.5 1.5 0 1 0 0 3h6.5V20a1.5 1.5 0 1 0 3 0v-6.5H20a1.5 1.5 0 1 0 0-3'
      fill={props.color ?? BLUE}
      fillRule='evenodd'
    />
  </svg>
)

export default Plus
